<!--
 * @Description:
 * @Date: 2021-06-24 18:07:50
-->
<template>
  <div>
    <el-button
      size="medium"
      type="primary"
      style="height: 40px"
      plain
      @click="exportExcel($parent.searchQuery)"
    >
      导出
    </el-button>
  </div>
</template>

<script>
import { makeSure } from '@/tools';
import qs from 'qs';

export default {
  name: 'table-top-handler',
  methods: {
    // 导出表格数据
    exportExcel(query) {
      if (!this.$parent.tableData.length) {
        this.$alert('没有符合当前搜索条件的数据可以导出');
        return;
      }
      makeSure(
        this.$downloadFile.bind(
          this,
          `/rest/cso/saas/record/exportRecordSummaryList?${qs.stringify(
            query
          )}`,
          true,
          '',
          'post'
        )
      );
    }
  },
  created() {},
  beforeDestroy() {}
};
</script>

<style scoped lang="scss"></style>
